//@ts-nocheck
import { defineMessages } from 'react-intl';

export default defineMessages({
  // Training Section
  TRAINING: 'Training',
  TRAINING_OVERVIEW: 'Overview',
  TRAINING_SERIES: 'Series',
  TRAINING_MODULES: 'Modules',
  TRAINING_SERIES_OVERVIEW: 'Series overview pages',
  TRAINING_ILT: 'Instructor-led trainings (ILTs)',
  TRAINING_CERTIFICATIONS: 'Certificate templates',
  TRAINING_TAGS: 'Tags',
  TRAINING_MARKETPLACE: 'Marketplace',
  TRAINING_AI_TUTORIALS: 'Tutorials',

  // Assets Section
  ASSETS: 'Assets',
  ASSETS_HUBS: 'Hubs',
  ASSETS_ASSETS: 'Assets',
  ASSETS_ATTRIBUTES: 'Attributes',
  ASSETS_HUBS_OVERVIEW: 'Hub overview pages',

  // Call AI Section
  CALL_AI: 'Call AI',
  CALL_AI_LIBRARIES: 'Libraries',
  CALL_AI_TRAINING_CALLS: 'Training calls',

  // DSR (Rooms) Section
  DSR: 'Rooms',
  DSR_ROOMS: 'Rooms',
  DSR_TEMPLATES: 'Templates',
  DSR_INSIGHTS: 'Insights',
  DSR_DEALS: 'Deals & contacts',
  DSR_SETTINGS: 'Settings',

  // Content Center Section
  CONTENT_CENTER: 'Content Center',

  // Analytics Section
  ANALYTICS: 'Analytics',
  ANALYTICS_MY: 'My analytics',
  ANALYTICS_TRAINING: 'Training',
  ANALYTICS_USERS: 'Users and roles',
  ANALYTICS_ASSETS: 'Assets',
  ANALYTICS_CALL_AI: 'Call AI',
  ANALYTICS_COACHING: 'Coaching',
  ANALYTICS_RI: 'Readiness Index',

  // Users Section
  USERS: 'Users',
  USERS_USERS: 'Users',
  USERS_GROUPS: 'Groups',
  USERS_PROFILE: 'Profile fields',
  USERS_ROLES: 'Roles',

  // Account Settings Section
  ACCOUNT_SETTINGS: 'Account',
  ACCOUNT_SETTINGS_HOMEPAGES: 'Homepages',
  ACCOUNT_SETTINGS_EMAIL: 'Email templates',
  ACCOUNT_SETTINGS_AUTO_SUITE: 'Automation suite',
  ACCOUNT_SETTINGS_INTEGRATIONS: 'Integrations',
  ACCOUNT_SETTINGS_CUSTOM_PROPERTIES: 'Custom properties',
  ACCOUNT_SETTINGS_LOGS: 'System logs',
  ACCOUNT_SETTINGS_SETTINGS: 'Settings',

  CONTENT_CENTER_COLLAPSED: 'Content',
  ACCOUNT_SETTINGS_COLLAPSED: 'Account',
});
